export const ActivityChartSkeleton = ({
  width = '100%',
  height = '100%',
}: {
  width?: number | string;
  height?: number | string;
}) => {
  return (
    <svg
      className="animate-pulse"
      width={width}
      height={height}
      viewBox="0 0 1092 222"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="56"
        y1="149.5"
        x2="1061"
        y2="149.5"
        stroke="#F1F1F3"
      />
      <line
        x1="56"
        y1="101.5"
        x2="1061"
        y2="101.5"
        stroke="#F1F1F3"
      />
      <path
        d="M62 144C62 142.895 62.8954 142 64 142H68C69.1046 142 70 142.895 70 144V149H62V144Z"
        fill="#E4E3E7"
      />
      <path
        d="M95 144C95 142.895 95.8954 142 97 142H101C102.105 142 103 142.895 103 144V149H95V144Z"
        fill="#E4E3E7"
      />
      <path
        d="M128 119C128 117.895 128.895 117 130 117H134C135.105 117 136 117.895 136 119V149H128V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M161 119C161 117.895 161.895 117 163 117H167C168.105 117 169 117.895 169 119V149H161V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M194 101C194 99.8954 194.895 99 196 99H200C201.105 99 202 99.8954 202 101V149H194V101Z"
        fill="#E4E3E7"
      />
      <path
        d="M227 119C227 117.895 227.895 117 229 117H233C234.105 117 235 117.895 235 119V149H227V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M260 137C260 135.895 260.895 135 262 135H266C267.105 135 268 135.895 268 137V149H260V137Z"
        fill="#E4E3E7"
      />
      <path
        d="M293 129C293 127.895 293.895 127 295 127H299C300.105 127 301 127.895 301 129V149H293V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M326 115C326 113.895 326.895 113 328 113H332C333.105 113 334 113.895 334 115V149H326V115Z"
        fill="#E4E3E7"
      />
      <path
        d="M359 129C359 127.895 359.895 127 361 127H365C366.105 127 367 127.895 367 129V149H359V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M392 144C392 142.895 392.895 142 394 142H398C399.105 142 400 142.895 400 144V149H392V144Z"
        fill="#E4E3E7"
      />
      <path
        d="M425 144C425 142.895 425.895 142 427 142H431C432.105 142 433 142.895 433 144V149H425V144Z"
        fill="#E4E3E7"
      />
      <path
        d="M458 119C458 117.895 458.895 117 460 117H464C465.105 117 466 117.895 466 119V149H458V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M491 119C491 117.895 491.895 117 493 117H497C498.105 117 499 117.895 499 119V149H491V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M524 101C524 99.8954 524.895 99 526 99H530C531.105 99 532 99.8954 532 101V149H524V101Z"
        fill="#E4E3E7"
      />
      <path
        d="M557 119C557 117.895 557.895 117 559 117H563C564.105 117 565 117.895 565 119V149H557V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M590 101C590 99.8954 590.895 99 592 99H596C597.105 99 598 99.8954 598 101V149H590V101Z"
        fill="#E4E3E7"
      />
      <path
        d="M623 129C623 127.895 623.895 127 625 127H629C630.105 127 631 127.895 631 129V149H623V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M656 129C656 127.895 656.895 127 658 127H662C663.105 127 664 127.895 664 129V149H656V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M689 129C689 127.895 689.895 127 691 127H695C696.105 127 697 127.895 697 129V149H689V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M722 144C722 142.895 722.895 142 724 142H728C729.105 142 730 142.895 730 144V149H722V144Z"
        fill="#E4E3E7"
      />
      <path
        d="M755 144C755 142.895 755.895 142 757 142H761C762.105 142 763 142.895 763 144V149H755V144Z"
        fill="#E4E3E7"
      />
      <path
        d="M788 119C788 117.895 788.895 117 790 117H794C795.105 117 796 117.895 796 119V149H788V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M821 119C821 117.895 821.895 117 823 117H827C828.105 117 829 117.895 829 119V149H821V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M854 101C854 99.8954 854.895 99 856 99H860C861.105 99 862 99.8954 862 101V149H854V101Z"
        fill="#E4E3E7"
      />
      <path
        d="M887 119C887 117.895 887.895 117 889 117H893C894.105 117 895 117.895 895 119V149H887V119Z"
        fill="#E4E3E7"
      />
      <path
        d="M920 101C920 99.8954 920.895 99 922 99H926C927.105 99 928 99.8954 928 101V149H920V101Z"
        fill="#E4E3E7"
      />
      <path
        d="M953 129C953 127.895 953.895 127 955 127H959C960.105 127 961 127.895 961 129V149H953V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M986 129C986 127.895 986.895 127 988 127H992C993.105 127 994 127.895 994 129V149H986V129Z"
        fill="#E4E3E7"
      />
      <path
        d="M1019 129C1019 127.895 1019.9 127 1021 127H1025C1026.1 127 1027 127.895 1027 129V149H1019V129Z"
        fill="#E4E3E7"
      />
    </svg>
  );
};
